import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsHoldSizeM from './IconToolsHold_size_m';

const props: CreateIconArguments = {
  l: IconToolsHoldSizeM,
  m: IconToolsHoldSizeM,
  s: IconToolsHoldSizeM,
  xs: IconToolsHoldSizeM,
  name: 'IconToolsHold',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
